var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopWithTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9232 13.9237L16.2424 8.62944L15.1732 7.56024L10.9232 11.8102L8.79816 9.68524L7.74434 10.7391L10.9232 13.9237ZM1.38281 20.2294V18.7294H22.6135V20.2294H1.38281ZM4.30589 17.7294C3.80075 17.7294 3.37319 17.5544 3.02319 17.2044C2.67319 16.8544 2.49819 16.4269 2.49819 15.9217V5.53717C2.49819 5.03205 2.67319 4.60449 3.02319 4.25449C3.37319 3.90449 3.80075 3.72949 4.30589 3.72949H19.6904C20.1956 3.72949 20.6231 3.90449 20.9731 4.25449C21.3231 4.60449 21.4981 5.03205 21.4981 5.53717V15.9217C21.4981 16.4269 21.3231 16.8544 20.9731 17.2044C20.6231 17.5544 20.1956 17.7294 19.6904 17.7294H4.30589ZM4.30589 16.2294H19.6904C19.7674 16.2294 19.8379 16.1974 19.902 16.1333C19.9661 16.0692 19.9982 15.9987 19.9982 15.9217V5.53717C19.9982 5.46023 19.9661 5.38972 19.902 5.32562C19.8379 5.2615 19.7674 5.22944 19.6904 5.22944H4.30589C4.22895 5.22944 4.15843 5.2615 4.09431 5.32562C4.03021 5.38972 3.99816 5.46023 3.99816 5.53717V15.9217C3.99816 15.9987 4.03021 16.0692 4.09431 16.1333C4.15843 16.1974 4.22895 16.2294 4.30589 16.2294Z",
    fill: "#000032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopWithTick);
export default __webpack_public_path__ + "static/media/LaptopWithTick.539aa2bd6414475bbd46ca8265dfae25.svg";
export { ForwardRef as ReactComponent };